var _objectWithoutProperties = require("/opt/build/repo/packages/hsey/node_modules/@babel/runtime/helpers/objectWithoutProperties");

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).IconCheckCircle = t(e.React);
}(this, function (e) {
  "use strict";

  function t(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  var n = t(e),
      _r = function r() {
    return (_r = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var o in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  function o() {
    return (o = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  var a = function a(_ref) {
    var _ref$styles = _ref.styles,
        e = _ref$styles === void 0 ? {} : _ref$styles,
        t = _objectWithoutProperties(_ref, ["styles"]);

    return n.default.createElement("svg", o({
      className: (e["ef-icon"] || "ef-icon") + " " + (e["ef-svg"] || "ef-svg"),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      width: "32",
      height: "32"
    }, t), n.default.createElement("path", {
      d: "M16 0a16 16 0 1016 16A16 16 0 0016 0zm8.71 12.58L15.29 22l-.7.71a1.15 1.15 0 01-.33.21.94.94 0 01-.76 0 1.15 1.15 0 01-.33-.21l-.71-.71-5.16-5.17a1 1 0 010-1.41l.7-.71a1 1 0 011.41 0l4.46 4.46 8.71-8.71a1 1 0 011.41 0l.71.71a1 1 0 01.01 1.41z"
    }));
  },
      l = function l(e) {
    var t = e.className,
        o = function (e, t) {
      var n = {};

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
          t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
      }

      return n;
    }(e, ["className"]);

    return n.default.createElement(a, _r({
      className: ["ef-icon ef-svg", t].join(" ")
    }, o));
  };

  return l.displayName = "IconCheckCircle", l;
});